import Box from '@mui/material/Box';
import { ReactNode } from 'react';

import { blockSpacingSx, hasBlockSpacing } from 'src/helpers/blockSpacing';
import { IPageBlock } from 'src/interfaces/PageBlock';

export function wrapPageBlockWithSpacing(block: IPageBlock, node: ReactNode): ReactNode {
  if (!node || !hasBlockSpacing(block.spacing)) {
    return node;
  }
  return <Box sx={blockSpacingSx(block.spacing)}>{node}</Box>;
}
